import React, {createContext, useContext} from 'react'
import {useAutomationRules} from './useAutomationRules'

type AutomationRulesData = ReturnType<typeof useAutomationRules>

const AutomationRulesDataContext = createContext<AutomationRulesData | null>(null)

export const AutomationRulesDataProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const data = useAutomationRules()
  return (
    <AutomationRulesDataContext.Provider value={data}>
      {children}
    </AutomationRulesDataContext.Provider>
  )
}

export const useAutomationRulesData = (): AutomationRulesData => {
  const ctx = useContext(AutomationRulesDataContext)
  if (!ctx)
    throw new Error('useAutomationRulesData must be used within AutomationRulesDataProvider')
  return ctx
}
